import { createFileRoute } from "@tanstack/react-router";
import FAQ from "@/pages/FAQ";
import { SITE_URL, OG_IMAGE } from "@/lib/site-data";
import { breadcrumbLd, webPageLd } from "@/lib/seo";
import { faqLd } from "@/pages/FAQ";

const title = "Flooring FAQ | Installation Questions Answered | JTB Floors";
const description =
  "Common questions about hardwood, tile, laminate, and marble flooring installation, timelines, materials, and warranties. Answered by JTB Floors.";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/faq` },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/faq` }],
    scripts: [breadcrumbLd("FAQ", "/faq"), faqLd],
  }),
  component: FAQ,
});
